// src/auth/gateway-auth.ts
var AUTH_TYPES = {
  internal: {
    description: "Internal authentication for employees and services",
    allowedApplications: ["admin-portal", "qa-portal", "analytics-portal", "dashboard"]
  },
  external: {
    description: "External authentication for end users",
    // `publication-reader`: people OUTSIDE the platform's tenancy — a
    // publication's realtime reader and the email-verified guest. Platform-
    // issued (never Auth0), holding no scope but `publications:participate`.
    allowedApplications: ["dashboard", "selfservice-portal", "publication-reader"]
  }
};
var APPLICATIONS = {
  dashboard: {
    name: "User Dashboard",
    description: "Main application dashboard for end users",
    type: "external"
  },
  "admin-portal": {
    name: "Admin Portal",
    description: "Internal portal for application management",
    type: "internal"
  },
  "qa-portal": {
    name: "QA Portal",
    description: "Internal portal for quality assurance",
    type: "internal"
  },
  "selfservice-portal": {
    name: "Self-Service Portal",
    description: "Customer-facing self-service administration",
    type: "external"
  },
  "analytics-portal": {
    name: "Analytics Portal",
    description: "Internal analytics and reporting",
    type: "internal"
  },
  // No Auth0 client: the platform issues these sessions itself (outsider tokens).
  "publication-reader": {
    name: "Publication reader",
    description: "Outsiders reading a shared investigation: reader tickets and email-verified guests",
    type: "external"
  }
};
var AUTH_FIELDS = ["org_id", "tenant_id", "user_id", "type", "application"];
var HEALTH_CHECK_SENTINEL = "health-check";
function isValidAuthType(authType) {
  return authType.toLowerCase() in AUTH_TYPES;
}
function isValidApplication(application) {
  return application in APPLICATIONS;
}
function getApplicationType(application) {
  const spec = APPLICATIONS[application];
  if (!spec) throw new Error(`Invalid application: ${application}`);
  return spec.type;
}
function isApplicationAllowedForType(authType, application) {
  if (!isValidAuthType(authType) || !isValidApplication(application)) {
    return false;
  }
  return AUTH_TYPES[authType.toLowerCase()].allowedApplications.includes(
    application
  );
}
function getAllowedApplications(authType) {
  if (!isValidAuthType(authType)) throw new Error(`Invalid auth type: ${authType}`);
  return AUTH_TYPES[authType.toLowerCase()].allowedApplications;
}
function canAccessApplication(authType, application) {
  if (!authType) return false;
  return isApplicationAllowedForType(authType, application);
}

export { APPLICATIONS, AUTH_FIELDS, AUTH_TYPES, HEALTH_CHECK_SENTINEL, canAccessApplication, getAllowedApplications, getApplicationType, isApplicationAllowedForType, isValidApplication, isValidAuthType };
//# sourceMappingURL=chunk-DQNP4KXT.js.map
//# sourceMappingURL=chunk-DQNP4KXT.js.map